import SectionEvents from './SectionEvents';
export default SectionEvents;
